import React, { useState } from "react";
import "../styles/certificates.css";

const Certificates = () => {
	const [popupSrc, setPopupSrc] = useState(null);

	const certificates = [
		{
			src: "/images/certificates/prep-course-Git-HTML-CSS.jpeg",
			label: "Preparatory Course - Git, HTML, CSS",
		},
		{
			src: "/images/certificates/Cert-traversymedia.jpg",
			label: "Modern JavaScript - Traversy Media",
		},
		{
			src: "/images/certificates/prep-course-MongoDB.jpeg",
			label: "Preparatory Course - MongoDB",
		},
		{
			src: "/images/certificates/MySQL.jpeg",
			label: "MySQL Database",
		},
		{
			src: "/images/certificates/Tech Career Program - Full Stack.jpeg",
			label: "Full Stack Web Development - MERN",
		},
		
	];

	return (
		<div className="certificates_container">
			<h1 className="certificates_title">Certificates</h1>

			<div className="certificates_div">
				{certificates.map((cert, i) => (
					<div className="cert_item" key={i}>
						<img
							src={cert.src}
							alt={cert.label}
							className="thumbnail"
							onClick={() => setPopupSrc(cert.src)}
						/>
						<p>{cert.label}</p>
					</div>
				))}
			</div>

			{/* Popup Modal */}
			{popupSrc && (
				<div className="popup-overlay" onClick={() => setPopupSrc(null)}>
					<span className="popup-close">X</span>

					<img
						src={popupSrc}
						alt="Full Certificate"
						className="popup-image"
						onClick={(e) => e.stopPropagation()} // Prevent parent click
					/>
				</div>
			)}
		</div>
	);
};

export default Certificates;
